import styles from './ProgressBar.module.scss';
interface ProgressBarProps {
  progress: number;
}

export function ProgressBar({ progress }: ProgressBarProps) {
  return (
    <div className={styles.ProgressBar}>
      <progress value={progress} min="1" max="100" className={styles.Control} />
      <div className={styles.Indicator} style={{ width: `${progress}%` }}>
        <span className={styles.Label}>{progress} %</span>
      </div>
    </div>
  );
}
